import { render, staticRenderFns } from "./createmenubutton.vue?vue&type=template&id=6fd6bc14&"
import script from "./createmenubutton.vue?vue&type=script&lang=ts&"
export * from "./createmenubutton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createmenubutton.vue"
export default component.exports